module.exports = __webpack_public_path__ + "img/black.d5015e3a.svg";